import { render, staticRenderFns } from "./dict-type.vue?vue&type=template&id=761820e5&scoped=true"
import script from "./dict-type.vue?vue&type=script&lang=js"
export * from "./dict-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761820e5",
  null
  
)

export default component.exports